export const S3_DEST_FILE_FORMATS: any[] = [
  {
    name: 'JSON',
    value: 'JSON'
  }
];
